/**
 * Copyright (c) samjay.dev.
 *
 * Notes:
 * This source code is the private property of samjay.dev.
 * You cannot modify, share or copy these source codes without any formal authorization,
 * otherwise samjay.dev reserves the right to pursue any legal action.
 *
 * Developer: Sam Tsang (info@samjay.dev)
 */

import React, { useState } from 'react';
import { InView } from 'react-intersection-observer';
import {
  Link, useLocation
} from "react-router-dom";
import { getSvgIcon } from '../../resources';
import AppDevelopment from '../../scss/main/App.development.module.scss';
import AppStyle from '../../scss/main/App.module.scss';
import AppProduction from '../../scss/main/App.production.module.scss';
import BAD from './More/Backend';
import MAD from './More/Mobile';
import WAD from './More/Web';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store/types';
import { Action } from 'store/slices';

const Skill: React.FC<{}> = () => {

  const dispatch = useDispatch();
  const backStyle = useSelector((state: RootState) => state.ui.backStyle);
  const isIOS = (navigator.maxTouchPoints > 1 && !/Windows/.test(navigator.userAgent)) || /iPad|iPhone|iPod|Mobile/.test(navigator.userAgent)

  const setBackStyle = (backStyle: boolean, title?: string) => {
    dispatch(Action.setBackStyle({ backStyle, title: title ?? '' }))
  }

  let location = useLocation();
  const tab = location && location.pathname
  if (tab === '/skills/mobile') {
    setBackStyle(true, 'Mobile')
  } else if (tab === '/skills/web') {
    setBackStyle(true, 'Web')
  } else if (tab === '/skills/cloud') {
    setBackStyle(true, 'Cloud')
  } else if (backStyle) {
    setBackStyle(false)
  }

  return (
    <div className={AppStyle["skill"]}>
      <div>
        <div>
          <div>
            <video id={isIOS ? AppStyle['isIOS-video'] : AppStyle['isNonIOS-video']} autoPlay={true} loop={true} playsInline={true} controls={true} muted={true} src={process.env.REACT_APP_CDN_PATH + '277fcb43286f134d6182fbd538c4be8056f069e4d612410290645d65a5614b7e.webm'} />
            <div id={isIOS ? AppStyle['isIOS-image'] : AppStyle['isNonIOS-image']} style={{ backgroundImage: `url('${process.env.REACT_APP_CDN_PATH + '277fcb43286f134d6182fbd538c4be8056f069e4d612410290645d65a5614b7e.webp'}')` }} />
          </div>
          <InView triggerOnce>
            {({ inView, ref, entry }) => (
              <div className={`${inView && AppStyle['descAnimA']}`} style={{ opacity: !inView ? '0.0' : '1.0' }} ref={ref}>
                <div>
                  Knowledge. Learning. Innovation.
                </div>
                <div>
                  {!tab ? 'About My Skill.' : tab === 'mobile' ? 'Mobile Application' : tab === 'web' ? 'Web Application' : tab === 'cloud' ? 'Backend, Database and Cloud' : 'About My Skill.'}
                </div>
              </div>
            )}
          </InView>
        </div>
        {tab === "/skills" ?
          <div>
            <div>
              <div>
                <div>
                  <InView triggerOnce>
                    {({ inView, ref, entry }) => (
                      <div className={`${inView && AppStyle['descAnimC']}`} style={{ opacity: !inView ? '0.0' : '1.0' }} ref={ref}>
                        <div><div>Mobile Applications Technology</div></div>
                      </div>
                    )}
                  </InView>
                  <InView triggerOnce>
                    {({ inView, ref, entry }) => (
                      <div className={`${inView && AppStyle['descAnimC']}`} style={{ opacity: !inView ? '0.0' : '1.0' }} ref={ref}>
                        <><div><div>The development of Mobile Applications is a challenging task. Every process of</div></div><div><div>user interface design, functional design, development and production release</div></div><div><div>also will affect the final development result. Therefore, this requires good</div></div><div><div>planning from the beginning.</div></div></>
                      </div>
                    )}
                  </InView>
                  <InView triggerOnce>
                    {({ inView, ref, entry }) => (
                      <div className={`${inView && AppStyle['descAnimC']}`} style={{ opacity: !inView ? '0.0' : '1.0' }} ref={ref}>
                        <div><div>The development of Mobile Applications is a challenging task. Every process of user interface design, functional design, development and production release also will affect the final development result. Therefore, this requires good planning from the beginning.</div></div>
                      </div>
                    )}
                  </InView>
                  <InView triggerOnce>
                    {({ inView, ref, entry }) => (
                      <div className={`${inView && AppStyle['descAnimC']}`} style={{ opacity: !inView ? '0.0' : '1.0' }} ref={ref}>
                        <div className={`${AppStyle["buttonLine"]}`}>
                          <div>
                            <Link to='/skills/mobile'>
                              Learn More
                              <div className={AppStyle["button-border"]} />
                            </Link>
                          </div>
                        </div>
                      </div>
                    )}
                  </InView>
                </div>
                <div>
                  <div>
                    <div>
                      <div>
                        <InView triggerOnce>
                          {({ inView, ref, entry }) => (
                            <div className={`${inView && AppStyle['descAnimG']} ${process.env.NODE_ENV === 'development' ? AppDevelopment["development-skill-container-main-container-box-vectorbox-double-left-top-box"] : AppProduction["production-skill-container-main-container-box-vectorbox-double-left-top-box"]}`} style={{ opacity: !inView ? '0.0' : '0.0' }} ref={ref}>
                              <img src={process.env.REACT_APP_CDN_PATH + "8a5b86874d8065a92a6145294bebc2d31fa7529cd82d0e76d7c8e437e79485cf.webp"} />
                            </div>
                          )}
                        </InView>
                      </div>
                      <div>
                        <InView triggerOnce>
                          {({ inView, ref, entry }) => (
                            <div className={`${inView && AppStyle['descAnimG']} ${process.env.NODE_ENV === 'development' ? AppDevelopment["development-skill-container-main-container-box-vectorbox-double-left-bottom-box"] : AppProduction["production-skill-container-main-container-box-vectorbox-double-left-bottom-box"]}`} style={{ opacity: !inView ? '0.0' : '0.0' }} ref={ref}>
                              <img src={process.env.REACT_APP_CDN_PATH + "2266f9d60d718807c9ae1f3aa66be6aec46845f3acadd097b16b0984b1544fee.webp"} />
                            </div>
                          )}
                        </InView>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div>
                      <div>
                        <InView triggerOnce>
                          {({ inView, ref, entry }) => (
                            <div className={`${inView && AppStyle['descAnimF']}`} style={{ opacity: !inView ? '0.0' : '1.0' }} ref={ref} dangerouslySetInnerHTML={{ __html: `${getSvgIcon({ name: "mad1" })}` }} />
                          )}
                        </InView>
                        <InView triggerOnce>
                          {({ inView, ref, entry }) => (
                            <div className={`${inView && AppStyle['descAnimF']}`} style={{ opacity: !inView ? '0.0' : '1.0' }} ref={ref} dangerouslySetInnerHTML={{ __html: `${getSvgIcon({ name: "mad2" })}` }} />
                          )}
                        </InView>
                        <InView triggerOnce>
                          {({ inView, ref, entry }) => (
                            <div className={`${inView && AppStyle['descAnimF']}`} style={{ opacity: !inView ? '0.0' : '1.0' }} ref={ref} dangerouslySetInnerHTML={{ __html: `${getSvgIcon({ name: "mad3" })}` }} />
                          )}
                        </InView>
                        <InView triggerOnce>
                          {({ inView, ref, entry }) => (
                            <div className={`${inView && AppStyle['descAnimF']}`} style={{ opacity: !inView ? '0.0' : '1.0' }} ref={ref} dangerouslySetInnerHTML={{ __html: `${getSvgIcon({ name: "mad4" })}` }} />
                          )}
                        </InView>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div>
                      <div>
                        <InView triggerOnce>
                          {({ inView, ref, entry }) => (
                            <div className={`${inView && AppStyle['descAnimH']} ${process.env.NODE_ENV === 'development' ? AppDevelopment["development-skill-container-main-container-box-vectorbox-double-right-top-box"] : AppProduction["production-skill-container-main-container-box-vectorbox-double-right-top-box"]}`} style={{ opacity: !inView ? '0.0' : '0.0' }} ref={ref}>
                              <img src={process.env.REACT_APP_CDN_PATH + "3bbdde03b427198b7d46ff5dff47c66f60c28b2436df0db2cc88325d1e597a96.webp"} />
                            </div>
                          )}
                        </InView>
                      </div>
                      <div>
                        <InView triggerOnce>
                          {({ inView, ref, entry }) => (
                            <div className={`${inView && AppStyle['descAnimH']} ${process.env.NODE_ENV === 'development' ? AppDevelopment["development-skill-container-main-container-box-vectorbox-double-right-bottom-box"] : AppProduction["production-skill-container-main-container-box-vectorbox-double-right-bottom-box"]}`} style={{ opacity: !inView ? '0.0' : '0.0' }} ref={ref}>
                              <img src={process.env.REACT_APP_CDN_PATH + "42d7bddec7589caf679032a153aebb37c6bb3f534cd40c2d0474036b64ec132b.webp"} />
                            </div>
                          )}
                        </InView>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div>
                  <InView triggerOnce>
                    {({ inView, ref }) => (
                      <div className={`${inView && AppStyle['descAnimC']}`} style={{ opacity: !inView ? '0.0' : '1.0' }} ref={ref}>
                        <div><div>Web Applications Technology</div></div>
                      </div>
                    )}
                  </InView>
                  <InView triggerOnce>
                    {({ inView, ref }) => (
                      <div className={`${inView && AppStyle['descAnimC']}`} style={{ opacity: !inView ? '0.0' : '1.0' }} ref={ref}>
                        <><div><div>The modern website is no longer a pure existence as a website. It can be an</div></div><div><div>application or even comparable to the experience of a mobile application.</div></div><div><div>To accomplish this pioneering work, both the design of the user interface</div></div><div><div>and the lightweight structure are essential.</div></div></>
                      </div>
                    )}
                  </InView>
                  <InView triggerOnce>
                    {({ inView, ref }) => (
                      <div className={`${inView && AppStyle['descAnimC']}`} style={{ opacity: !inView ? '0.0' : '1.0' }} ref={ref}>
                        <div>The modern website is no longer a pure existence as a website. It can be an application or even comparable to the experience of a mobile application. To accomplish this pioneering work, both the design of the user interface and the lightweight structure are essential.</div>
                      </div>
                    )}
                  </InView>
                  <InView triggerOnce>
                    {({ inView, ref }) => (
                      <div className={`${inView && AppStyle['descAnimC']}`} style={{ opacity: !inView ? '0.0' : '1.0' }} ref={ref}>
                        <div className={`${AppStyle["skill-container-main-container-box-titlebox-btnbox-btn"]} ${AppStyle["buttonLine"]}`}>
                          <div>
                            <Link to='/skills/web'>
                              Learn More
                              <div className={AppStyle["button-border"]} />
                            </Link>
                          </div>
                        </div>
                      </div>
                    )}
                  </InView>
                </div>
                <div>
                  <div>
                    <div>
                      <div>
                        <InView triggerOnce>
                          {({ inView, ref, entry }) => (
                            <div className={`${inView && AppStyle['descAnimC']}`} style={{ opacity: !inView ? '0.0' : '1.0' }} ref={ref}>
                              <div>
                                <div><div>1</div></div>
                              </div>
                              <div>
                                <div>UI/UX Design Thinking</div>
                              </div>
                              <div>
                                <div>Design thinking focuses on human-centered design. It means providing solutions for humans, with an accent on fulfilling a particular human need.</div>
                              </div>
                            </div>
                          )}
                        </InView>
                        <InView triggerOnce>
                          {({ inView, ref, entry }) => (
                            <div className={`${inView && AppStyle['descAnimC']}`} style={{ opacity: !inView ? '0.0' : '1.0' }} ref={ref}>
                              <div>
                                <div><div>2</div></div>
                              </div>
                              <div>
                                <div>Structure Design</div>
                              </div>
                              <div>
                                <div>To ensure the stability of the website, a lightweight structure is the most important step. React, Vue and Angular are also representatives.</div>
                              </div>
                            </div>
                          )}
                        </InView>
                      </div>
                    </div>
                    <InView triggerOnce>
                      {({ inView, ref, entry }) => (
                        <div className={`${inView && AppStyle['descAnimF']}`} style={{ opacity: !inView ? '0.0' : '1.0' }} ref={ref}>
                          <div className={`${process.env.NODE_ENV === 'development' ? AppDevelopment["development-skill-container-main-container-box-vectorbox-center-box"] : AppProduction["production-skill-container-main-container-box-vectorbox-center-box"]}`}>
                            <img src={process.env.REACT_APP_CDN_PATH + "2e9838036e92f97ec4a7d5b1637a6654dd6f0a48acf86f8f995f92cc2955a96a.webp"} />
                          </div>
                        </div>
                      )}
                    </InView>
                    <div>
                      <div>
                        <InView triggerOnce>
                          {({ inView, ref, entry }) => (
                            <div className={`${inView && AppStyle['descAnimC']}`} style={{ opacity: !inView ? '0.0' : '1.0' }} ref={ref}>
                              <div>
                                <div><div>3</div></div>
                              </div>
                              <div>
                                <div>SEO</div>
                              </div>
                              <div>
                                <div>SEO is the process of improving the quality and quantity of website traffic to a website or a web page from search engines such as Google and Bing.</div>
                              </div>
                            </div>
                          )}
                        </InView>
                        <InView triggerOnce>
                          {({ inView, ref, entry }) => (
                            <div className={`${inView && AppStyle['descAnimC']}`} style={{ opacity: !inView ? '0.0' : '1.0' }} ref={ref}>
                              <div>
                                <div><div>4</div></div>
                              </div>
                              <div>
                                <div>Security and Performance</div>
                              </div>
                              <div>
                                <div>Security and Performance are the key factors for the success of a Web Apps. Among them, the compatibility of different devices is one of the indicators of performance requirements.</div>
                              </div>
                            </div>
                          )}
                        </InView>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div>
                  <InView triggerOnce>
                    {({ inView, ref, entry }) => (
                      <div className={`${inView && AppStyle['descAnimC']}`} style={{ opacity: !inView ? '0.0' : '1.0' }} ref={ref}>
                        <div><div>Backend, Database and Cloud</div></div>
                      </div>
                    )}
                  </InView>
                  <InView triggerOnce>
                    {({ inView, ref, entry }) => (
                      <div className={`${inView && AppStyle['descAnimC']}`} style={{ opacity: !inView ? '0.0' : '1.0' }} ref={ref}>
                        <><div><div>Databases and APIs are the indispensable brains of an application. It is</div></div><div><div>responsible for processing, encrypting, calculating and storing data. Among them,</div></div><div><div>safety and efficiency are one of the factors that need to be considered when</div></div><div><div>designing these structures.</div></div></>
                      </div>
                    )}
                  </InView>
                  <InView triggerOnce>
                    {({ inView, ref, entry }) => (
                      <div className={`${inView && AppStyle['descAnimC']}`} style={{ opacity: !inView ? '0.0' : '1.0' }} ref={ref}>
                        <div>Databases and APIs are the indispensable brains of an application. It is responsible for processing, encrypting, calculating and storing data. Among them, safety and efficiency are one of the factors that need to be considered when designing these structures.</div>
                      </div>
                    )}
                  </InView>
                  <InView triggerOnce>
                    {({ inView, ref, entry }) => (
                      <div className={`${inView && AppStyle['descAnimC']}`} style={{ opacity: !inView ? '0.0' : '1.0' }} ref={ref}>
                        <div className={`${AppStyle["skill-container-main-container-box-titlebox-btnbox-btn"]} ${AppStyle["buttonLine"]}`}>
                          <div>
                            <Link to='/skills/cloud'>
                              Learn More
                              <div className={AppStyle["button-border"]} />
                            </Link>
                          </div>
                        </div>
                      </div>
                    )}
                  </InView>
                </div>
                <InView triggerOnce>
                  {({ inView, ref, entry }) => (
                    <div className={`${inView && AppStyle['descAnimF']}`} style={{ opacity: !inView ? '0.0' : '1.0' }} ref={ref}>
                      <div dangerouslySetInnerHTML={{ __html: `${getSvgIcon({ name: "server_vector" })}` }} />
                    </div>
                  )}
                </InView>
              </div>
            </div>
          </div>
          : <><div></div>{tab === '/skills/mobile' ? <MAD /> : tab === '/skills/web' ? <WAD /> : tab === '/skills/cloud' ? <BAD /> : ''}</>}
      </div>
    </div>
  )
}

export default Skill